// extracted by mini-css-extract-plugin
module.exports = {"Menu":"MenuToggle_Menu__10M6o","MenuBtn":"MenuToggle_MenuBtn__2J70u"};